// extracted by mini-css-extract-plugin
export default {"PageContainer":"collaboration-overview-page_PageContainer__PwKxx"};